import { ReceiptRefundIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";
import { buildCrudPermissions, permissionId } from "../../shared/featureFactories";

export const RefundsFeature: FeatureMetadata = {
  id: "refunds",
  moduleName: "feesFinance",
  navigation: {
    label: "Refunds",
    path: "/refunds",
    icon: ReceiptRefundIcon,
    order: 9,
  },
  route: {
    path: "/refunds",
    element: lazy(() => import("./pages/Refunds")),
  },
  permissions: buildCrudPermissions("FeeFinance", "Refunds", {
    view: permissionId("FeeFinance", "Refunds", "process"),
    create: permissionId("FeeFinance", "Refunds", "process"),
    edit: permissionId("FeeFinance", "Refunds", "process"),
    delete: permissionId("FeeFinance", "Refunds", "process"),
  }),
  readiness: "live",
};
